import { render, staticRenderFns } from "./ProcessHistoryEntry.vue?vue&type=template&id=0389d0d6"
import script from "./ProcessHistoryEntry.vue?vue&type=script&lang=js"
export * from "./ProcessHistoryEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports